import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { BGInformInvention, BGInformInventionResponse } from '../models/bgInformInvention.model';
import { InventorInformation, InventorInformationResponse } from '../models/inventorInformation.model';
import { UniversalPayment, UniversalPaymentResponse } from '../models/universalPayment.model';
import { delayedRetryHttp } from '../shared/delayedRetry';
import { UtilityService } from './shared/utility.service';

@Injectable()
export class InfoCollectService {
  private baseUrl: string;
  private api: string = "api/InfoCollect";

  constructor(private httpClient: HttpClient, @Inject('BASE_URL') _baseUrl: string, private _utilityService: UtilityService) {
    this.baseUrl = _baseUrl + this.api;
  }

  private handleErrors(errorResponse: HttpErrorResponse) {
    if (errorResponse.error instanceof ErrorEvent) {
      console.error('InfoCollect Service Client Side Error: ', errorResponse.error.message);
    } else {
      throw errorResponse;
    }
  }

  async BGInformInvention_CreateAsync(encryptedUser: string, bgInformInventionResponse: BGInformInventionResponse): Promise<BGInformInventionResponse | void> {
    const a = await this.httpClient.post<BGInformInventionResponse>(this.baseUrl, bgInformInventionResponse, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Basic ' + encryptedUser
      })
    }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, bgInformInventionResponse, "", encryptedUser, "InfoCollectService", "BGInformInvention_CreateAsync"); });
 
    return a;
  }

  async BGInformInvention_GetAsync(encryptedUser: string, inventionId: number, contractSessionId: number): Promise<BGInformInventionResponse | void> {
    const a = await this.httpClient
      .get<BGInformInventionResponse>(`${this.baseUrl}/BGInformInvention_Get/${inventionId}/${contractSessionId}`, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': 'Basic ' + encryptedUser
        })
      }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "inventionId - " + inventionId + " contractSessionId -" + contractSessionId, encryptedUser, "InfoCollectService", "BGInformInvention_GetAsync"); });
 
    return a;
  }

  async InventorInvention_GetAsync(encryptedUser: string, inventionId: number, contractSessionId: number): Promise<InventorInformationResponse | void> {
    const a = await this.httpClient
      .get<InventorInformationResponse>(`${this.baseUrl}/InventorInvention_Get/${inventionId}/${contractSessionId}`, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': 'Basic ' + encryptedUser
        })
      }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "inventionId - " + inventionId + " contractSessionId -" + contractSessionId, encryptedUser, "InfoCollectService", "InventorInvention_GetAsync"); });


    return a;
  }

  async InventorInvention_CreateAsync(encryptedUser: string, inventorInformationResponse: InventorInformationResponse): Promise<InventorInformationResponse | void> {
    const a = await this.httpClient.post<InventorInformationResponse>(`${this.baseUrl}/InventorInformation_Create/`, inventorInformationResponse, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Basic ' + encryptedUser
      })
    }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, inventorInformationResponse, "",encryptedUser, "InfoCollectService", "InventorInvention_CreateAsync"); });
 

    return a;
  }

  async UniversalPayment_CreateAsync(encryptedUser: string, universalPaymentResponse: UniversalPaymentResponse): Promise<UniversalPaymentResponse | void> {   
    const a = await this.httpClient.post<UniversalPaymentResponse>(`${this.baseUrl}/UniversalPayment_Create/`, universalPaymentResponse, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': 'Basic ' + encryptedUser
        })
    }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, universalPaymentResponse, "",encryptedUser, "InfoCollectService", "UniversalPayment_CreateAsync"); });
 

    return a;
  }

  async UniversalPayment_GetAsync(encryptedUser: string, inventionId: number, contractSessionId: number): Promise<UniversalPaymentResponse | void> {
    const a = await this.httpClient
      .get<UniversalPaymentResponse>(`${this.baseUrl}/UniversalPayment_Get/${inventionId}/${contractSessionId}`, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': 'Basic ' + encryptedUser
        })
      }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "inventionId - " + inventionId + " contractSessionId - " + contractSessionId, encryptedUser, "InfoCollectService", "UniversalPayment_GetAsync"); });
 

    return a;
  }
}
